import { render, staticRenderFns } from "./MenuBottomSheet.vue?vue&type=template&id=395760e2&"
import script from "./MenuBottomSheet.vue?vue&type=script&lang=js&"
export * from "./MenuBottomSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('395760e2')) {
      api.createRecord('395760e2', component.options)
    } else {
      api.reload('395760e2', component.options)
    }
    module.hot.accept("./MenuBottomSheet.vue?vue&type=template&id=395760e2&", function () {
      api.rerender('395760e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/core/MenuBottomSheet.vue"
export default component.exports